import { forwardRef, useId } from 'react';
import clsx from 'clsx';

const Textarea = forwardRef(({
  label,
  error,
  hint,
  required,
  rows = 4,
  className,
  textareaClassName,
  id,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  ...props
}, ref) => {
  const reactId = useId();
  const textareaId = id || `textarea-${reactId}`;
  const errorId = `${textareaId}-error`;
  const hintId = `${textareaId}-hint`;
  const describedBy = clsx(ariaDescribedBy, hint && hintId, error && errorId) || undefined;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
          {required && !String(label).includes('*') && (
            <span aria-hidden="true" className="ml-0.5 font-normal text-danger-500">*</span>
          )}
        </label>
      )}
      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        required={required}
        aria-label={!label ? ariaLabel : undefined}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        className={clsx(
          'input-field',
          error && 'border-danger-500 focus:ring-danger-500 focus:border-danger-500',
          textareaClassName
        )}
        {...props}
      />
      {hint && <p id={hintId} className="mt-1.5 text-sm text-slate-500">{hint}</p>}
      {error && (
        <div role="alert">
          <p id={errorId} className="mt-1.5 text-sm font-medium text-danger-700">{error}</p>
        </div>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';
export default Textarea;
